import ChangeRequestDetail from './ChangeRequestDetail';

export default ChangeRequestDetail;
